import * as actionTypes from './actionTypes';

export function filtersInitialize(filterName: string): Object {
  return {
    type: actionTypes.FILTERS_INITIALIZE,
    payload: {
      filterName,
    },
  };
}

export function filtersUpdate(filterName: string, filters: Object): Object {
  return {
    type: actionTypes.FILTERS_UPDATE,
    payload: {
      filterName,
      filters,
    },
  };
}

export function filterByChange(filterName: string, filterBy: string, ids: string[] = []): Object {
  return {
    type: actionTypes.FILTER_BY_CHANGE,
    payload: {
      filterName,
      filterBy,
      ids,
    },
  };
}

export function filtersReset(filterName: string): Object {
  return {
    type: actionTypes.FILTERS_RESET,
    payload: {
      filterName,
    },
  };
}
